import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import Services from '../services';

const HR_CLEARANCE_FORM_OPTIONS = {
  hrbp: (onClickHandler: () => void, slug?: string) => [
    {
      icon: <PictureAsPdfIcon />,
      label: 'Download PDF',
      link: `${Services.api.hr.downloadClearanceFormPDF(slug)}`,
      type: 'download',
    },
  ],

  finalized: (onClickHandler: () => void, slug?: string) => [
    {
      icon: <PictureAsPdfIcon />,
      label: 'Download PDF',
      link: `${Services.api.hr.downloadClearanceFormPDF(slug)}`,
      type: 'download',
    },
  ],
  other: (onClickHandler: () => void, slug?: string) => [
    {
      icon: <PersonAddAlt1Icon />,
      label: 'Add Signatory',
      clickHandler: onClickHandler,
      type: 'action',
    },

    {
      icon: <PictureAsPdfIcon />,
      label: 'Download PDF',
      link: `${Services.api.hr.downloadClearanceFormPDF(slug)}`,
      type: 'download',
    },
  ],
};

export const hrClearanceFormOptions = (
  status: string,
  onClickHandler: () => void,
  slug?: string,
) => {
  switch (status) {
    case 'hrbp':
      return HR_CLEARANCE_FORM_OPTIONS.hrbp(onClickHandler, slug);
    case 'finalized':
      return HR_CLEARANCE_FORM_OPTIONS.finalized(onClickHandler, slug);
    case 'other':
      return HR_CLEARANCE_FORM_OPTIONS.other(onClickHandler, slug);
  }
};
